// ======================================================================
// File Name       : ServiceLoginAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { updateAuthUserService } from '../actions/AuthAction';
import { DEFAULT_DATE_FORMAT_SEARCH } from '../constants';
import { SERVICE_LOGIN, SERVICE_SEARCH } from '../constants/ActionTypes';
import { BILLING_SYSTEM_REGISTER_FLAG_STATUS } from '../constants/EnterpriseConstants';
import { usageSettingAuthConstants } from '../constants/FunctionAuthConstants';
import { commonCallApi } from '../utils/ApiUtils';
import { IS_SHOW_LIVE_TAB, LIVE_MANAGEMENT_AUTHORITY_TYPE } from '../constants/AuthorityConstant';

/**
 * Action service get list
 * @param {*} searchInfo
 */
export function serviceSearch(searchInfo) {
  return dispatch => commonCallApi({
    path: 'service/GetList',
    data: searchInfo,
    enterpriseId: 1,
  }).then((camelizeJson) => {
    dispatch(receiveServiceList(camelizeJson));
  });
}

/**
 * Store service list
 * @param {*} serviceInfo
 */
function receiveServiceList(serviceInfo) {
  return {
    type: SERVICE_SEARCH,
    serviceInfo,
  };
}

// Step10.0.0 START
/**
 * Action login service for certificate login api gateway url
 * @param {*} serviceInfo
 * @param {*} selectedService 
 * @param {*} certificateData
 */
export function doLoginServiceCheck(serviceInfo, selectedService, certificateData) {
  return (dispatch) => {
    commonCallApi({
      path: 'auth/CertificateUsageCheck',
      data: certificateData,
    })
      .then((camelizeJson) => {
        const { certificateUsageFlag, certificateLoginApiGatewayUrl } = camelizeJson;
        if (certificateUsageFlag) {
          dispatch(doLoginService(serviceInfo, selectedService, certificateLoginApiGatewayUrl));
        } else {
          dispatch(doLoginService(serviceInfo, selectedService));
        }
      });
  };
}
// Step10.0.0 END

/**
 * Action login service
 * @param {*} serviceInfo
 */
export function doLoginService(serviceInfo, selectedService, certificateLoginApiGatewayUrl) { // Step10.0.0
  return (dispatch) => {
    commonCallApi({
      path: 'auth/LoginService',
      data: serviceInfo,
      enterpriseId: 1,
      certificateLoginApiGatewayUrl, // Step10.0.0
    }).then((camelizeJson) => {
      if (selectedService && camelizeJson && camelizeJson.managementFunctionAuthorityInfo) {
        const {
          contentManagementAuthority,
          liveManagementAuthority,
        } = camelizeJson.managementFunctionAuthorityInfo;
        const { usageSettingInfo } = selectedService;
        const content = contentManagementAuthority || 0;
        const live = liveManagementAuthority || 0;
        if (Object.keys(usageSettingInfo).length) {
          for (const key in usageSettingInfo) {

            let authority = content && usageSettingInfo[key] ? content : 0;
            camelizeJson.managementFunctionAuthorityInfo[key] = authority;
          }
        }
      }
      // sprint_20230508_#19 START
      if (selectedService) {
        const {
          contractEnterpriseBillingSystemRegisterFlag,
          contractEnterpriseStartDate,
          dormantUserDataAcquisitionPermissionFlag,
          mfaUsageFlag, // Step10.0.0
        } = selectedService;
        const currentDate = moment().format(DEFAULT_DATE_FORMAT_SEARCH);
        camelizeJson.isTrialExpire =
          contractEnterpriseStartDate <= currentDate &&
          contractEnterpriseBillingSystemRegisterFlag === BILLING_SYSTEM_REGISTER_FLAG_STATUS.NOT_REGISTERED;
        camelizeJson.dormantUserDataAcquisitionPermissionFlag = dormantUserDataAcquisitionPermissionFlag;
        camelizeJson.mfaUsageFlag = mfaUsageFlag; //Step 10.0.0
      }
      // sprint_20230508_#19 END
      dispatch(updateAuthUserService(serviceInfo.serviceCd, camelizeJson));
      dispatch(receiveServiceLoginInfo(camelizeJson));
    });
  };
}

/**
 * Store login service info
 * @param {*} serviceInfo
 */
function receiveServiceLoginInfo(serviceLoginInfo) {
  return {
    type: SERVICE_LOGIN,
    serviceLoginInfo,
  };
}
